<template lang="pug">
  div
    //.is-bold
    .hero
      .hero-body
        .title {{ $t("Excel to ecoSpold2 Web Converter")}}
        .sub-title {{ $t("Upload, validation and conversion of ecoSpold2, Dataset Excel Template and User Master Data files.")}}
    .section
      // h1.title {{ $t('Upload Files') }}
      file-uploads
</template>

<script>
import { CONTENT_TYPE_XLSX, CONTENT_TYPE_XML } from '../utils/api'
import FileUploads from './FileUploads'
export default {
  name: 'Overview',
  components: { FileUploads },
  data() {
    return {
      mimeTypes: CONTENT_TYPE_XLSX + ',' + CONTENT_TYPE_XML,
      errors: []
    }
  },
  created() {
    if (!this.$store.getters.disclaimerAccepted) {
      this.$dialog.alert({
        title: 'Disclaimer',
        message: `<b>Definitions</b><br>
          "You" means the individual or business entity that is using or accessing
          the Services, including its employees and agents.<br>
          "We" means ecoinvent.<br>
          "Services" means all the components of the Excel to ecoSpold2 Web Converter
          (including websites, data upload and download facilities and data conversion programs)
          offered to convert one unique dataset from ecoSpold or excel to the relevant excel or ecoSpold format.<br>
          "Source Data" means any data inputted or uploaded by you.<br>
          "Output Data" means any data converted to the relevant product format.<br><br>
          <b>Disclaimer, Limited Warranties and Limitation of Liability</b><br>
          The Services is provided on an “as is” and “as available” basis.
          Use of the Services is at your own risk.
          The Services converts the Source Data into the Output Data.
          Successful conversion only guaranties that the Source Data can be opened in ecoinvent’s
          software but not a suggestion of fitness for integration into the ecoinvent database.
          You acknowledge and agree that We will not be responsible for any failure to convert Source Data.
          You acknowledge and agree that We will not be responsible for loss of any data,
          information or content contained in Source Data or Output Data.
          You bear full responsibility for archiving and backing up your Source Data and sole liability for any lost or irrecoverable Source Data.
        `,
        confirmText: this.$t('Accept'),
        type: 'is-warning',
        onConfirm: () => this.$store.commit('disclaimerAccepted')
      })
    }
  },
  computed: {
    hasErrors() {
      return !!this.errors.length
    }
  },
  methods: {
    startConversion() {
      this.clearUploads()
    }
  }
}
</script>

<style scoped>
  .hero-body {
    padding-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Overview.vue